import { StorageServices } from '@/services/StorageServices';
import { createStore } from 'vuex'
import * as OM from '@/model';
import * as VM from '@/viewmodel';
import * as Enum from '@/enum';
import * as env from '@/config';
import { ModalServices } from '@/services/ModalServices';
import { BaseUserClient, VillageConfigClient } from '@/services/Services';
import { LocalizationServices } from '@/services/LocalizationServices';


let vuestore = {
    state: {
        env: env,
        loginData: <OM.LoginData>null,
        user: <OM.Lead>null,
        auracoinMultiplier: 1,
        selectedLanguage: "",
        villageConfig: <OM.VillageConfig>null,
        villageByCoords: <OM.VillageConfig>null,
        consts: {
            localizedValues: [],
            enabledLanguages: [],
            projectConfig: <OM.ProjectConfigVm>{
                name: "",
                colors: new OM.ProjectColors(),
                siteUrl: ""
            },
        },
        clubSubscription: <OM.ClubSubscription>null,
        agentSubscription: <OM.AgentSubscription>null,
        paymentConfig: <OM.PaymentConfigVm>null,
        showSpinner: 0,
        isMobile: false,
        scrollFunction: <(ev) => void> null,
        beforeNavCbs: [],
        afterNavCbs: [],
        isInThisVillage: false,
        hideSaldo: false,
        getVillageByCoords: (update: boolean = false) => {
            return new Promise<OM.VillageConfig>((resolve, reject) => {
                if(!update && store.state.villageByCoords)
                    resolve(store.state.villageByCoords);
                
                navigator.geolocation.getCurrentPosition(
                    (val) => {
                        store.state.saveLastPositionItem(val);

                        let lat = val.coords.latitude;
                        let long = val.coords.longitude;
                        VillageConfigClient.getVillageByCoords(lat, long)
                        .then(x => {
                            store.state.villageByCoords = x;
                            if(store.state.villageConfig){
                                store.state.isInThisVillage = store.state.villageConfig.identifier == store.state.villageByCoords.identifier;
                            }
                            resolve(x);
                        })
                    }, 
                    (err) => {
                        store.state.isInThisVillage = false;
                        store.state.villageByCoords = null;
                        reject(err);
                    }, {
                        enableHighAccuracy: true,
                        maximumAge: 5 * 60 * 1000,
                    }
                )
            })
        },
        saveLastPositionItem: (geolocation: GeolocationPosition) => {
            let lastDate = StorageServices.getLastPositionTime();
            if(!lastDate || new Date(lastDate).getTime() < Date.now() - 1000 * 60 * 60 * 4){
                BaseUserClient.savePositionHistoryItem({
                    lat: geolocation.coords.latitude,
                    lng: geolocation.coords.longitude,
                    date: new Date().toISOString()
                }, false)
                .then(x => {
                    StorageServices.setLastPositionTime(new Date().toISOString());
                })
            }
        },
        systemCopy: copyToClipboard,
        inAppNotificationsCount: 0,
        isPushAuthorized: <boolean> true,
        isCameraAuthorized: <boolean> true,
        hasNewChatMessages: <OM.HasNewChatMessagesVm>{
            network: false,
            villages: {}
        },
        openInAppNotificationsModal: () => {
            ModalServices.inAppNotificationsModal();
        },
        isCordova: false,
        formErrors: <{ [key: string]: boolean }>{},
        backButtonFunction: null,
        openBrowser: ($event) => {
            let findParentWithHref = (element) => {
                if (element.href) {
                    return element.href;
                } else if (element.parentElement) {
                    return findParentWithHref(element.parentElement);
                }
                return null;
            };
            
            let url;
            if ($event.target) {
                $event.preventDefault();
                url = findParentWithHref($event.target);
            } else {
                url = $event;
            }
            
            if (url) {
                if (!window.cordova) {
                    window.open(url, "_blank");
                } else {
                    window.cordova.InAppBrowser.open(url, "_system");
                }
            } else {
                console.error("Nessun URL trovato nell'elemento o nei suoi parent.");
            }
        },
        isLead: (role?: string) => {
            let checkWith = role ? role : vuestore.state.user && vuestore.state.user.role;
            return checkWith == Enum.UserRoles.Lead;
        },
        isCollaboratore: (role?: string) => {
            let checkWith = role ? role : vuestore.state.user && vuestore.state.user.role;
            return checkWith == Enum.UserRoles.Collaboratore;
        },
        isAdmin: (role?: string) => {
            let checkWith = role ? role : vuestore.state.user && vuestore.state.user.role;
            return checkWith == Enum.UserRoles.Admin;
        },
    }
}

vuestore.state.isMobile = window.innerWidth <= 768;
window.addEventListener('resize', () => {
    store.state.isMobile = window.innerWidth <= 768;
})

vuestore.state.villageConfig = StorageServices.getVillageConfig();
vuestore.state.loginData = StorageServices.getLoginData();

let store = createStore(vuestore);

const unwatch = store.watch(
    (state, getters) => [ state.villageConfig, state.villageByCoords ],
    () => {
        if(!store.state.villageConfig || !store.state.villageByCoords){
            store.state.isInThisVillage = false
        } else {
            if(store.state.villageByCoords && store.state.villageByCoords){
                store.state.isInThisVillage = store.state.villageConfig.identifier == store.state.villageByCoords.identifier;
            } else {
                store.state.isInThisVillage = false;
            }
        }
    },
    { immediate: false, deep: false } // opzionale
);


export default store


function copyToClipboard(text, clickEv: MouseEvent = null) {
    var dummy = document.createElement("textarea");
    // to avoid breaking orgain page when copying more words
    // cant copy when adding below this code
    // dummy.style.display = 'none'
    document.body.appendChild(dummy);
    //Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
    
    if(clickEv){
        var popup = document.createElement("div");
        popup.style.position = "fixed";
        popup.style.left = clickEv.clientX - 25 + "px";
        popup.style.top = clickEv.clientY - 25 + "px";
        popup.style.backgroundColor = "transparent";
        popup.style.border = "none";
        popup.style.pointerEvents = "none";
        popup.style.touchAction = "none";
        popup.innerHTML = '<img src="' + require('@/img/check.png') + '" />'; // "<img src=\"https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Check_mark.svg/220px-Check_mark.svg.png\" />";
        document.body.append(popup);
        setTimeout(() => {
            popup.remove();
        }, 800);
    }
    
}